import { useEffect, useRef } from 'react';
import { useFirmBaseLayoutContext } from './FirmBaseLayoutContext';
import type { FirmBaseLayoutNavigationRegistrationToken } from './FirmBaseLayoutContext.types';
import type { TertiaryNavigationState } from './tertiaryNavigation.types';

export const useTertiaryNavigationRegistration = (tertiaryNavigation: TertiaryNavigationState | null) => {
  const registrationTokenRef = useRef<FirmBaseLayoutNavigationRegistrationToken>(Symbol('tertiary-navigation'));
  const registrationToken = registrationTokenRef.current;
  const { clearTertiaryNavigation, registerTertiaryNavigation } = useFirmBaseLayoutContext();

  // Register updates whenever tertiaryNavigation changes. registerTertiaryNavigation bails out via
  // areTertiaryNavigationStatesEqual when content is unchanged, preventing spurious context updates.
  useEffect(() => {
    registerTertiaryNavigation(registrationToken, tertiaryNavigation);
  }, [registerTertiaryNavigation, registrationToken, tertiaryNavigation]);

  // Clear only on unmount so that route-transition cleanup never races with the incoming route's register call.
  // Keeping clear separate prevents the combined cleanup→register cycle from bypassing the bail-out above.
  useEffect(() => () => {
    clearTertiaryNavigation(registrationToken);
  }, [clearTertiaryNavigation, registrationToken]);
};
